<template>
    <div>
      <div class="card">
        <div class="card-header">
            <div class="col-md-12">
              <ol class="breadcrumb breadcrumb-card-header pull-left">
                  <li class="breadcrumb-item">
                  <a href="javascript:void(0);" @click="backParent">Unit Of Measure</a>
                  </li>
                  <li class="breadcrumb-item active">
                      <span v-if="uom.id === null">New</span>
                      <span v-else>
                        {{ uom.name }}
                      </span>
                  </li>
              </ol>
            </div>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-6">
                  <div class="form-group row">
                      <label for="name" class="col-sm-3 col-form-label text-left">Name</label>
                      <div class="col-sm-9">
                          <input type="text" v-model="uom.name" class="form-control"/>
                      </div>
                  </div>
                  <div class="form-group row">
                      <label for="category_id" class="col-sm-3 col-form-label text-left">Category</label>
                      <div class="col-sm-9">
                          <select v-model="uom.category_id" class="form-control">
                              <option v-for="c in uomCategoryList" :key="c.id" :value="c.id">{{ c.name }}</option>
                          </select>
                      </div>
                  </div>
                  <div class="form-group row">
                      <label for="type_id" class="col-sm-3 col-form-label text-left">Type</label>
                      <div class="col-sm-9">
                          <select v-model="uom.type_id" class="form-control">
                              <option v-for="t in uomTypeList" :key="t.id" :value="t.id">{{ t.name }}</option>
                          </select>
                      </div>
                  </div>
                  <div class="form-group row">
                      <label for="ratio" class="col-sm-3 col-form-label text-left">Ratio</label>
                      <div class="col-sm-9">
                          <input type="text" v-model="uom.ratio" class="form-control"/>
                      </div>
                  </div>
                  <div class="form-group row">
                      <label for="canBarcode" class="col-sm-3 col-form-label text-left"></label>
                      <div class="col-sm9">
                          <div class="custom-control custom-checkbox">
                              <input type="checkbox" id="active" data-parsley-multiple="groups" data-parsley-mincheck="2" class="custom-control-input" v-model="uom.active">
                              <label for="active" class="custom-control-label">Active</label>
                          </div>
                      </div>
                  </div>
                </div>
            </div>
        </div>
        <div class="card-footer">
          <button type="button" @click="backParent" class="btn btn-sm btn-danger pull-left"><i class="fa fa-reply" aria-hidden="true"></i> Back</button>
          <button type="button" @click="updateUom" class="btn btn-sm btn-primary pull-right" v-show="idUom !== null"><i class="fa fa-save" aria-hidden="true"></i> Update</button>
          <button type="button" @click="createUom" class="btn btn-sm btn-primary pull-right" v-show="idUom == null"><i class="fa fa-check" aria-hidden="true"></i> Save</button>
        </div>
      </div>
      <!-- <pre>{{ idUom }}</pre> -->
      <!-- <pre>{{ uom }}</pre> -->
    </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { uomUrl, getHeader } from '@/config'

export default {
  name: 'UnitOfMeasureForm',
  props: ['uom', 'idUom'],
  computed: {
    ...mapState({
      uomTypeList: state => state.uom.uomTypeList,
      uomCategoryList: state => state.uom.uomCategoryList
    })
  },
  methods: {
    backParent: function () {
      this.$emit('backClicked')
    },
    updateUom () {
      axios.put(uomUrl + '/' + this.idUom, this.uom, { headers: getHeader() })
        .then(response => {
          this.$swal(
            'Unit Of Measure',
            response.data.message,
            'success'
          )
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    },
    createUom () {
      axios.post(uomUrl, this.uom, { headers: getHeader() })
        .then(response => {
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error!!',
            '<pre>' + error.response.data.message + '</pre>',
            'error'
          )
        })
    }
  }
}
</script>
